/**
 * Created by Steven-DESK on 12/06/2017.
 */

$(document).ready(function () {
    let gemeentes = [];
    $(".led_gemeente").keyup(function () {

        let val = $(".led_gemeente").val();
        $.ajax({
            url: '/Api/Gemeentes/'+ val,
            success: function (data) {
                gemeentes = [];
                $.each(JSON.parse(data), function (i,item) {
                    gemeentes.push(item.Postcode + " " + item.Gemeente);
                })
            }
        });
        $(".led_gemeente").autocomplete({
            source: gemeentes,
        })
    })
});



//////////////////
// WEBPACK FOOTER
// ./js/led_auto_com.js
// module id = 19
// module chunks = 0